import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pedidos',
  templateUrl: './pedidos.component.html',
  styleUrls: ['./pedidos.component.scss']
})
export class PedidosComponent implements OnInit {
  pedidos: any[] = [];
  filtroDataInicial: string = '';
  filtroDataFinal: string = '';
  filtroCliente: string = '';
  filtroStatus: string = '';

  constructor() { }

  ngOnInit(): void {
    // Mock data
    this.pedidos = [
      {
        numero: 'PED001',
        cliente: 'João Silva',
        data: new Date('2024-03-15'),
        valor: 12500.00,
        status: 'Em andamento'
      },
      {
        numero: 'PED002',
        cliente: 'Maria Santos',
        data: new Date('2024-03-14'),
        valor: 8750.50,
        status: 'Concluído'
      },
      {
        numero: 'PED003',
        cliente: 'Empresa ABC Ltda',
        data: new Date('2024-03-13'),
        valor: 23450.75,
        status: 'Aguardando pagamento'
      },
      {
        numero: 'PED004',
        cliente: 'Carlos Oliveira',
        data: new Date('2024-03-12'),
        valor: 5675.25,
        status: 'Em produção'
      },
      {
        numero: 'PED005',
        cliente: 'Ana Pereira',
        data: new Date('2024-03-11'),
        valor: 9875.00,
        status: 'Entregue'
      },
      {
        numero: 'PED006',
        cliente: 'Empresa XYZ S.A.',
        data: new Date('2024-03-10'),
        valor: 45600.00,
        status: 'Em andamento'
      },
      {
        numero: 'PED007',
        cliente: 'Roberto Almeida',
        data: new Date('2024-03-09'),
        valor: 3250.80,
        status: 'Concluído'
      },
      {
        numero: 'PED008',
        cliente: 'Comércio ABC',
        data: new Date('2024-03-08'),
        valor: 18750.30,
        status: 'Aguardando pagamento'
      }
    ];
  }
} 